/** Check if a point is inside a polygon region using ray-casting algorithm */
export function pointInPolygon(wx: number, wy: number, p: { points: Array<{ x: number; y: number }> }): boolean {
  const pts = p.points;
  if (pts.length < 3) return false;
  let inside = false;
  for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
    const xi = pts[i].x, yi = pts[i].y;
    const xj = pts[j].x, yj = pts[j].y;
    if ((yi > wy) !== (yj > wy) && wx < ((xj - xi) * (wy - yi)) / (yj - yi) + xi) {
      inside = !inside;
    }
  }
  return inside;
}
